<ion-header>
  <app-page-header popoverCssClass='resources'></app-page-header>
  <app-resources-header [title]='"Trainings/Workshops"' [showSort]="false"></app-resources-header> 
</ion-header>

<ion-content appScrollBounce>
  <div class='bottom'>
    <div [ngClass]="['contents', resourcesCssService.responsiveClass()]">
      <div class='overview' [innerHTML]="sidebarContent">
        <p>From live workshops, to online learning and videos, to an advanced certification training program 
          (and more!), we provide you with the resources you need to teach fun and engaging classes, stay on 
          top of advances in early childhood education, and keep expanding and honing your skills.</p>
        <p><a href="https://www.facebook.com/groups/1525195257704280/" target="_blank" class="facebook"><i class="mt-facebook"></i>Connect on Facebook</a></p>
      </div>

      <div class='items'>
        <div class='list'>
          <ng-container *ngFor='let training of trainings; trackBy: trackByUuid'>
            <app-training [training]='training'></app-training>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ion-content>